import React from 'react';
import styles from './VendorMachineErrorModal.module.css';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import cancelIcon from 'routes/vendorRe/images/cancel_icon.png';
import P from 'components/P';
import online from 'routes/vendor/storemanage/images/online.png';
import offline from 'routes/vendor/storemanage/images/offline.png';
import error from 'routes/vendor/storemanage/images/error.png';

// 스타일 변수
const fontSize = 'max(0.9vw, 10px)';

const VendorMachineErrorModal = ({ callbackFn, machine }) => {
    const machineTypeText =
        machine.storeMachineType === 'kiosk' ? '키오스크' : '액상 자판기';

    let statusImage, statusText;
    switch (machine.storeMachineStatus) {
        case 'error':
            statusImage = error;
            statusText = '오류';
            break;
        case 'online':
            statusImage = online;
            statusText = '정상';
            break;
        case 'offline':
            statusImage = offline;
            statusText = '오프라인';
            break;
        default:
            statusImage = null;
            statusText = '';
            break;
    }

    return (
        <div className={styles.layer}>
            <div className={styles.popup}>
                <Container padding="1vw" backgroundColor="white">
                    <VerticalFlex gap="1rem">
                        <FlexChild alignItems="flex-end">
                            <div className={styles.cancelBtn}>
                                <img
                                    className={styles.cancel}
                                    src={cancelIcon}
                                    onClick={() => {
                                        if (callbackFn) {
                                            callbackFn();
                                        }
                                    }}
                                    alt="모달창 닫기"
                                />
                            </div>
                        </FlexChild>
                        <FlexChild alignItems="flex-start">
                            <HorizontalFlex gap="1rem">
                                <FlexChild width="auto">
                                    <div
                                        className={
                                            machine.storeMachineType === 'kiosk'
                                                ? styles.kiosk
                                                : styles.vending
                                        }
                                    >
                                        {machineTypeText}
                                    </div>
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex gap="0.5rem">
                                        <FlexChild alignItems="flex-start">
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P
                                                        size={fontSize}
                                                        padding="0 0.5rem 0 0"
                                                    >
                                                        {machine.storeName}
                                                    </P>
                                                    <P size={fontSize}>
                                                        {machineTypeText}
                                                    </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild alignItems="flex-start">
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <img
                                                        className={
                                                            styles.status
                                                        }
                                                        src={statusImage}
                                                        alt={statusText}
                                                    />
                                                    <span
                                                        className={
                                                            styles.statusText
                                                        }
                                                    >
                                                        {statusText}
                                                    </span>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P>01.</P>
                                            <P>어떤 오류가 발생했나요?</P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap="1rem">
                                        <FlexChild>
                                            <div>1</div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div>1</div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div>1</div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <HorizontalFlex gap="1rem">
                                        <FlexChild>
                                            <div>1</div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div>1</div>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex>
                                <FlexChild>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P>02.</P>
                                            <P>
                                                자세한 오류 상황을 적어주세요.
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <textarea placeholder="오류 상황을 자세히 기재해 주세요."></textarea>
                                    <P>
                                        본사 확인 후 1일 내로 연락드리겠습니다.
                                    </P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <div>오류 접수</div>
                        </FlexChild>
                    </VerticalFlex>
                </Container>
            </div>
        </div>
    );
};

export default VendorMachineErrorModal;
